import { render, staticRenderFns } from "./CurrencyAmountList.vue?vue&type=template&id=79461368&"
import script from "./CurrencyAmountList.vue?vue&type=script&lang=js&"
export * from "./CurrencyAmountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports